import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { ProjektFlowchartComponent } from './main/projektflowchart.component';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';

// dashboard
const routes: Routes = [
	{
		path: 'flowchart',
		component: ProjektFlowchartComponent,
		data: { title: 'Projekt Flowchart Dashboard' },
		canActivate: [AuthGuard],
	},
	{
		path: 'details/:itemId',
		data: { title: 'Workflow Details' },
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('../../workflow/components/details/workflow-details.module').then(
				m => m.WorkflowDetailsModule
			)
	},
	{
		path: 'overview/:itemId/:viewMode',
		data: { title: 'Fragebogen Übersicht' },
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('../../workflow/components/questionnaire/overview/questionnaire-overview.module').then(
				m => m.QuestionnaireOverviewModule
			)
	},
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(routes)],
	providers: [],
	exports: [RouterModule]
})
export class ProjektflowchartRouterModule {}
